import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { Button } from "@totalsoft/rocket-ui";
import NotificationItemComponent from "./NotificationItemComponent";
import { NotificationsBoxContainer } from "./NotificationStyles";

class NotificationListComponent extends Component {
  state = {
    isInfiniteLoading: false
  };

  iScroll = React.createRef();

  componentDidMount() {
    this.iScroll.current.addEventListener("scroll", this.onScroll);
  }

  componentWillUnmount() {
    this.iScroll.current.removeEventListener("scroll", this.onScroll);
  }

  handleInfiniteLoad = async () => {
    this.setState({ isInfiniteLoading: true });

    await this.props.loadMoreNotifications();

    this.setState({ isInfiniteLoading: false });
  };

  ElementInfiniteLoad = () => {
    return <div>{this.props.t("Notifier.Loading")}</div>;
  };

  onScroll = async () => {
    const notifierBox = this.iScroll.current;
    const notifierBoxRectangle = notifierBox.getBoundingClientRect();
    const lastItemRectangle = notifierBox.lastElementChild.getBoundingClientRect();

    if (!this.state.isInfiniteLoading && lastItemRectangle.top < notifierBoxRectangle.bottom) {
      await this.handleInfiniteLoad();
    }
  };

  render() {
    const { notifications, t, handleMarkAsRead, handleDismiss, handleDismissAll } = this.props;

    return (
      <Grid container>
        <Grid item xs={12} sx={{ textAlign: "end", mb: 1 }}>
          <Button color="primary" size="small" variant="text" onClick={handleDismissAll} sx={{ textTransform: "none" }}>
            {t("Notifier.DismissAll")}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <NotificationsBoxContainer ref={this.iScroll}>
            {notifications.map(notification => {
              const text = notification.translatable
                ? t(notification.notificationTitle, {
                    data: notification.notificationBody || notification.sourceContextKeys
                  })
                : notification.notificationTitle;
              return (
                <NotificationItemComponent
                  key={notification.notificationId}
                  notification={notification}
                  text={text}
                  onMarkAsRead={handleMarkAsRead}
                  onDismiss={handleDismiss}
                />
              );
            })}
            {this.state.isInfiniteLoading && <this.ElementInfiniteLoad />}
          </NotificationsBoxContainer>
        </Grid>
      </Grid>
    );
  }
}

NotificationListComponent.propTypes = {
  notifications: PropTypes.array.isRequired,
  t: PropTypes.func,
  handleMarkAsRead: PropTypes.func.isRequired,
  handleDismiss: PropTypes.func.isRequired,
  handleDismissAll: PropTypes.func.isRequired,
  loadMoreNotifications: PropTypes.func.isRequired
};

export default withTranslation()(NotificationListComponent);
